const asyncDelay = (duration: number) =>
  new Promise((resolve) => setTimeout(resolve, duration));

const RESPONSE_TIME = 700;

export const emulateServer = <
  T extends (...args: Parameters<T>) => ReturnType<T>,
>(
  method: T,
  responseTime = RESPONSE_TIME,
) => {
  return async (...args: Parameters<T>) => {
    await asyncDelay(responseTime);

    return {
      data: await method(...args),
    };
  };
};
